
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";

import util from "../lib/util";
import AbpBase from "../lib/abpbase";
import appconst from "../lib/appconst";
import url from "../lib/url";
@Component({})
export default class Main extends AbpBase {
  chsnow: boolean = true;

  outer: boolean = false;
  showai: boolean = false;
  style: string = "padding:58px 10px 0px;height: 100%;";
  // IT维修
  showToolIT: boolean = false;
  updateTool: object = {};
  toolPics: Array<any> = new Array<any>();
  imagebox: boolean = false;
  rules = {
    question: [
      {
        required: true,
        message: this.L("标题不能为空"),
        trigger: "blur",
      },
    ],
    description: [
      {
        required: true,
        message: this.L("描述不能为空"),
        trigger: "blur",
      },
    ],
  };
  created() {
    var domain = sessionStorage.getItem("domain");
    if (domain && domain != null && domain != "") {
      this.outer = true;
      this.style = "padding:0px 10px 10px;height: 100%;";
    } else {
    }

    if (abp.localization.currentLanguage.name == "en") {
      this.chsnow = false;
    } else {
      this.chsnow = true;
    }

    if (
      util.abp.auth.grantedPermissions.AppAIUser != undefined &&
      util.abp.auth.grantedPermissions.AppAIUser.toLowerCase() == "true"
    ) {
      this.showai = true;
    } else {
      this.showai = false;
    }
  }
  logout() {
    this.$Modal.confirm({
      title: this.L("Tips"),
      content: this.L("退出确认"),
      okText: this.L("确认"),
      cancelText: this.L("Cancel"),
      onOk: async () => {
        this.$store.commit("/app/logout", this);
        util.abp.auth.clearToken();
        if (
          window.location.hostname.toLocaleLowerCase().indexOf("gistest") > -1
        ) {
          window.location.href =
            "https://gistest.yfpo.com:9105/sp_sso_login?enterpriseId=yf&redirectUrl=http%3A%2F%2Fgistest.yfpo.com%3A9105%2Fenduser%2Fsp%2Fsso%2Fyfjwt13%3FenterpriseId%3Dyf";
        } else {
          if (window.location.port == "9185") {
            window.location.href =
              "https://gis.yfpo.com:9105/sp_sso_login?enterpriseId=yf&redirectUrl=http%3A%2F%2Fgis.yfpo.com%3A9105%2Fenduser%2Fsp%2Fsso%2Fyfjwt70%3FenterpriseId%3Dyf";
          } else {
            window.location.href =
              "https://gis.yfpo.com:9105/sp_sso_login?enterpriseId=yf&redirectUrl=http%3A%2F%2Fgis.yfpo.com%3A9105%2Fenduser%2Fsp%2Fsso%2Fyfjwt5%3FenterpriseId%3Dyf";
          }
        }
        //window.location.href = appconst.gisLogout;
        // location.reload();
      },
    });
  }
  goAI() {
    var curlurl = localStorage.getItem("curl_url");
    if (curlurl != "" && curlurl != "") {
      var t = Math.round(Math.random() * 10);
      curlurl += "&t=" + t;
      window.open(curlurl, "_blank");
    } else {
      if (url.toLocaleLowerCase().indexOf("gistest") > -1) {
        var user = JSON.parse(localStorage.getItem("userInfo"));
        curlurl =
          "https://gistest.yfpo.com:9158/#/sessionai2?userid=" + user.Id;
      } else {
        var user = JSON.parse(localStorage.getItem("userInfo"));
        curlurl = "https://gis.yfpo.com:9158/#/sessionai2?userid=" + user.Id;
      }
      var t = Math.round(Math.random() * 10);
      curlurl += "&t=" + t;
      console.log(curlurl);
      window.open(curlurl, "_blank");
    }
  }

  async changeLanguage() {
    var languageName = "";
    if (abp.localization.currentLanguage.name == "en") {
      languageName = "zh-Hans";
    } else {
      languageName = "en";
    }

    await this.$store.dispatch({
      type: "user/changeLanguage",
      data: { languageName: languageName },
    });
    abp.utils.setCookieValue(
      "Abp.Localization.CultureName",
      languageName,
      new Date(new Date().getTime() + 5 * 365 * 86400000), //5 year
      abp.appPath
    );
    location.reload();
  }

  async upload(file) {
    let that = this;
    var form = new FormData();
    form.append("file", file);
    var res = await this.$store
      .dispatch({
        type: "app/uploadImage",
        data: form,
      })
      .then((res) => {
        that.toolPics.push(res);
        that.imagebox = true;
      });
  }
  handleRemove(index) {
    this.toolPics.splice(index, 1);
  }
  handleSuccess(res, file) {}
  handleUpload(file) {
    const fileExt = file.name.split(".").pop().toLocaleLowerCase();
    if (fileExt === "jpeg" || fileExt === "jpg" || fileExt === "png") {
      this.upload(file);
    } else {
      this.$Notice.warning({
        title: this.L("文件类型错误"),
        desc: this.L("文件不是图片").replace("{0}", file.name),
      });
    }
    return false;
  }
  async saveFile() {
    (this.$refs.toolForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.$Message.loading({
          content: this.L("报修中"),
          duration: 0,
        });
        const params = Object.assign(
          {
            pictures: this.toolPics.join(","),
            type: 2,
          },
          this.updateTool
        );
        var res = await this.$store
          .dispatch({
            type: "app/createAnswer",
            data: params,
          })
          .then((res) => {
            if (res.success) {
				this.$Message.success(this.L("报修提交成功"));
              this.cancelFile();
            } else {
              this.$Message.error(this.L("报修提交失败"));
            }
          })
          .finally(() => {
            this.$Message.destroy();
          });
      }
    });
  }
  cancelFile() {
    (this.$refs.toolForm as any).resetFields();
    this.updateTool = {};
    this.toolPics = [];
    this.showToolIT = false;
  }
}
